package com.macrofocus.nastac.components

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.nastac.ui.react.toState
import js.objects.unsafeJso
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import mui.icons.material.PlayCircleOutlineOutlined
import mui.icons.material.StopCircleOutlined
import mui.material.IconButton
import mui.material.IconButtonColor
import mui.material.Size
import mui.material.Slider
import react.FC
import react.Props
import react.dom.events.SyntheticEvent
import react.useState
import web.cssom.px
import web.events.Event

external interface TimeSliderProps : Props {
    var shiftValue: MutableProperty<Int>
    var localShiftValue: MutableProperty<Int>
    var minYear: MutableProperty<Int>
    var maxYear: MutableProperty<Int>
    var enabled : Boolean
    var playEnabled : Boolean
    var valueEnabled : Boolean
    var steps : Int
}

val TimeSlider = FC<TimeSliderProps> { props ->
    val (getShiftValue, setShiftValue) = props.shiftValue.toState()
    val (getLocalShiftValue, setLocalShiftValue) = props.localShiftValue.toState()

    val (minYear, _) = props.minYear.toState()
    val (maxYear, _) = props.maxYear.toState()

    val (getJob, setJob) = useState<Job?>(null)

    if(!props.playEnabled) {
        val job = getJob
        if (job != null) {
            job.cancel()
            setJob(null)
        }
    }

    if(true) {
        IconButton {
            disabled = !props.playEnabled

            //                        classes(classes.menuButton)
            color = IconButtonColor.inherit
            //                    edge = IconButtonEdge.start
            onClick = {
                val job = getJob
                if (job != null) {
                    job.cancel()
                    setJob(null)
                } else {
                    val ms = 500L
                    println("Starting animation with 5 minutes = $ms ms")
                    setJob(GlobalScope.launch {
                        var current = getLocalShiftValue
                        while (true) {
                            delay(ms)
                            current = if (current < maxYear) current + 1 else minYear

                            //                                println("Next date: " + next.toRawString())
                            //                                masterDateTime.value = next.toDateTime()
//                            println("Shifting to $current")
                            setLocalShiftValue(current)
                            setShiftValue(current)
                        }
                    })
                }
            }

            if (getJob != null) StopCircleOutlined {} else PlayCircleOutlineOutlined {}
            //        Icon { +if(getJob != null) "stop_circle_outline_icon" else "play_circle_outline_icon" }
        }
    }

    Slider {
        sx = unsafeJso {
            width = 260.px
            marginLeft = 10.px
            marginTop = 5.px
            marginRight = 10.px
        }

        disabled = !props.enabled || getJob != null
        value = getLocalShiftValue
//                        getAriaValueText={valuetext}
        step = props.steps
        marks
        min = minYear
        max = maxYear
        size = Size.small
        if(props.valueEnabled) {
            valueLabelDisplay = "on"
            asDynamic().valueLabelPlacement = "bottom"
        }

        onChange = { event: Event, value: dynamic, activeThumb: Number ->
//            println("onChange: $value")
            if (value is Number) {
                setLocalShiftValue(value.toInt())
                if (props.playEnabled) {
                    setShiftValue(value.toInt()) // Comment out if value should only be set on release
                }
            }
        }
        onChangeCommitted = { event: SyntheticEvent<*, *>, value: dynamic ->
//            println("onChangeCommitted: $value")
            if (value is Number) {
                setLocalShiftValue(value.toInt())
                setShiftValue(value.toInt())
            }
        }
    }
}